import { computed, observable, action, reaction } from 'mobx';
import { api } from '../services';

import { catalogStore } from '.';

class ProfileStore {
  @observable profile = window.localStorage.getItem('dealer-profile') ? JSON.parse(window.localStorage.getItem('dealer-profile')) : {};

  @observable inProgress = false;

  constructor(catalogStore) {
    this.catalogStore = catalogStore;
    reaction(
      () => this.profile,
      profile => {
        if (profile) {
          window.localStorage.setItem('dealer-profile', JSON.stringify(profile));
        } else {
          window.localStorage.removeItem('dealer-profile');
        }
      }
    );
  }

  pullUser = () => {
    this.inProgress = true;
    return api({ action: 'profile' }).then(profile => {
      this.catalogStore.loadProducts(profile);
      this.setProfile(profile);
      this.inProgress = false;
    });
  };

  forgetUser = () => {
    this.setProfile();
  };

  @action
  setProfile(profile) {
    this.profile = profile;
  }

  @computed
  get devices() {
    return this.profile.assets.map(a => a.imei);
  }

  @computed
  get devicesWithVehicleType() {
    return this.profile.assets.map(a => {
      return {
        imei: a.imei,
        vehicleType: !a.vehicleType ? 'car' : a.vehicleType
      }
    });
  }

  @computed
  get paymentsMethods() {
    return this.profile.enabledPaymentGateway;
  }
}

export default new ProfileStore(catalogStore);



// WEBPACK FOOTER //
// ./src/stores/profileStore.js